import { BV_DEFAULT_THEME } from "./brackets-vault-theme.config";

/**
 * Set theme on page load based on (in order of priority):
 *  1. the user's preferred theme from the theme state provider
 *  2. BracketsVault default theme for first-time visitors
 *
 * This is done outside the Angular app to avoid a flash of unthemed content before it loads.
 */
const setTheme = () => {
  /**
   * If we cannot find a saved preference, use the BracketsVault default.
   * `theme_light` is hardcoded as the fallback class in the web app's index.html file.
   */
  const defaultTheme = BV_DEFAULT_THEME;
  const htmlEl = document.documentElement;
  let theme = defaultTheme;

  const themeFromState = window.localStorage.getItem("global_theming_selection");

  if (themeFromState) {
    if (themeFromState.indexOf("system") > -1) {
      theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    } else if (themeFromState.indexOf("dark") > -1) {
      theme = "dark";
    } else if (themeFromState.indexOf("light") > -1) {
      theme = "light";
    }
  }

  if (!htmlEl.classList.contains("theme_" + theme)) {
    htmlEl.classList.remove("theme_light", "theme_dark");
    htmlEl.classList.add("theme_" + theme);
  }
};

setTheme();
